import { IInitialState } from './interfaces/state';
import {
    GET_DEVICE_FAILED,
    GET_DEVICE_SUCCESS,
    SET_DEFAULT_STATE,
    SHOW_LOADING,
    TOGGLE_HARDWARE_ONLY,
    TOGGLE_INSURANCE,
    TOGGLE_TRADE_IN,
} from './constants';
import produce from 'immer';
import { getIsTauschbonusEligible } from './helpers/getIsTauschbonusEligible';
import { DeviceDetailAction } from './actions';

/**
 * Initial state
 */
export const initialState: IInitialState = {
    isHardwareOnly: false,
    isTradeIn: false,
    isTauschbonus: false,
    insuranceSelected: false,
    loading: false,
    payload: null,
    error: null,
    forceRerender: true,
};

/**
 * Hardware detail reducer
 * @param state
 * @param action
 */
const hardwareDetailReducer = (state: IInitialState = initialState, action: DeviceDetailAction) =>
    produce(state, (draft: IInitialState) => {
        switch (action.type) {
            case SHOW_LOADING:
                draft.loading = true;
                break;
            case GET_DEVICE_SUCCESS:
                draft.loading = false;
                draft.payload = action.payload;
                break;
            case GET_DEVICE_FAILED:
                draft.error = action.error;
                break;
            case TOGGLE_HARDWARE_ONLY:
                draft.isHardwareOnly = !state.isHardwareOnly;
                break;
            case SET_DEFAULT_STATE:
                draft.isHardwareOnly = action.isHardwareOnly;
                draft.insuranceSelected = action.insurance;
                draft.isTradeIn = action.isTradeIn;
                draft.isTauschbonus = action.isTauschbonus;
                break;
            case TOGGLE_INSURANCE:
                draft.insuranceSelected = action.isChecked;
                draft.forceRerender = action.forceRerender;
                break;
            case TOGGLE_TRADE_IN:
                draft.isTradeIn = action.force || !state.isTradeIn;
                draft.isTauschbonus = getIsTauschbonusEligible() ? draft.isTradeIn : false;
                break;
        }
    });

export default hardwareDetailReducer;
